module.exports = __webpack_public_path__ + "static/media/who-logo.5fd23fa8.svg";